import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Menu } from 'antd';
import * as actions from '../../../../state/actions/creators/pacientes.actioncreator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faBuilding, faUser } from '@fortawesome/pro-light-svg-icons';

export function GenderSelectPatient({
  watch,
  onChange,
  fotoPerfil,
  pacienteSelected,
  intl,
  create,
}) {
    const loadingPhotos = useSelector((state) => state.pacientesWorkspace.loadingPhotos);
    const [generoState, setGeneroState] = useState(pacienteSelected?.genero === 'M' ? 'Female' : (pacienteSelected?.genero === 'H' ? 'Male' : (pacienteSelected?.es_empresa === true ? 'Company' : (pacienteSelected?.genero === 'O' || create ? 'Others' : 'Custom'))));
    const [avatarPic, setAvatarPic] = useState();

    useEffect(() => {
        if(fotoPerfil != '' && !loadingPhotos){
          setAvatarPic(`data:image/jpeg;base64,${fotoPerfil}`);
          setGeneroState(pacienteSelected?.genero === 'M' ? 'Female' : (pacienteSelected?.genero === 'H' ? 'Male' : (pacienteSelected?.es_empresa === true ? 'Company' : (pacienteSelected?.genero === 'O' || create ? 'Others' : 'Custom'))));
        } 
      },[fotoPerfil]);

    const setGeneroMenu = (gen) => {
        setGeneroState(gen);
        onChange('es_empresa', false);
        onChange('genero', '');
        onChange('avatar', '');
        switch(gen){
          case 'Male':
            onChange('genero', 'H');
            break;
          case 'Female':
            onChange('genero', 'M');
            break;
          case 'Company':
            onChange('es_empresa', true);
            break;
          case 'Others':
            onChange('genero', 'O');
            break;
          case 'Custom':
            console.log('CUSTOM');
            break;    
          default:
            return;
        }
      }
    
      const handleChangeAvatar = (event) => {
        setGeneroMenu('Custom');
        setAvatarPic(URL.createObjectURL(event.target.files[0]));
        onChange('avatar', event.target.files[0]);
      }
      
      const MenuGeneroAvatar = (
        <Menu>
          <Menu.Item key="masculino" onClick={() => setGeneroMenu('Male')}>
            Masculino
          </Menu.Item>
          <Menu.Item key="femenino" onClick={() => setGeneroMenu('Female')}>
            Femenino
          </Menu.Item>
          <Menu.Item key="otros" onClick={() => setGeneroMenu('Others')}>
            Otros
          </Menu.Item>
          <Menu.Item key="empresa" onClick={() => setGeneroMenu('Company')}>
            Empresa
          </Menu.Item>
          <Menu.Item key="foto_avatar">
            <label htmlFor="avatar">Añadir foto</label>
            <input style={{display: 'none'}} type="file" id="avatar" name="avatar" accept="image/*" onChange={ handleChangeAvatar }/>
          </Menu.Item>
        </Menu>
      );

    return(
      <div className="topBox_NP flexRow">
        <h2>{intl.formatMessage({ id: 'pacientes.generic.titles.client_file' })}</h2>
        <div className="gender flexCol" style={{ marginTop: '72px'}}>
          <div className="avatar flexRow" style={{ marginLeft: '8px' }}>
            {(generoState != 'Others' && generoState != 'Company') &&
              <img
                src={generoState != 'Custom' ? `img/pacientes/${generoState}.svg`:
                    (generoState == 'Custom' ? avatarPic : '')}
                style={{width:"72px", height:"72px", borderRadius: '50%' }}
                alt={generoState}
              />
            }
            {generoState == 'Company' &&
              <FontAwesomeIcon icon={faBuilding} style={{width:"72px", height:"72px", borderRadius: '50%', color:'white', backgroundColor: '#444963', padding: '10px'}} />
            }
            {generoState == 'Others' &&
              <FontAwesomeIcon icon={faUser} style={{width:"72px", height:"72px", borderRadius: '50%', color:'white', backgroundColor: '#444963', padding: '10px'}} />
            }
          </div>
          { 
          !watch && 
          <Dropdown overlay={MenuGeneroAvatar}>
            <a className="ant-dropdown-link" onClick={e => e.preventDefault()} style={{marginTop: '8px'}}>
              {intl.formatMessage({ id: 'pacientes.generic.foto_y_sexo' })} <FontAwesomeIcon icon={ faAngleDown } />
            </a>
          </Dropdown>
          }       
        </div>
      </div>
    );
}